import { AxiosResponse } from "axios";

import {
  ICreatedIntegrationApiKey,
  ICreateIntegrationApiKeyRequest,
  IIntegrationApiKey,
  IIntegrationApiKeyClaim,
  IUpdateIntegrationApiKeyRequest,
} from "../../@types/admin/AdminIntegrationApiKey";
import { api } from "../api";

const BASE_URL = "/Retool/IntegrationApiKeys";

/**
 * Integration API keys admin page. Same Retool base and auth as the other
 * admin services. The create response carries the plain key once; nothing
 * here stores or logs it — the page shows it and forgets it.
 */
export const integrationApiKeysService = {
  async getApiKeys(): Promise<AxiosResponse<IIntegrationApiKey[]>> {
    return api.get<IIntegrationApiKey[]>(BASE_URL);
  },

  async getClaims(): Promise<AxiosResponse<IIntegrationApiKeyClaim[]>> {
    return api.get<IIntegrationApiKeyClaim[]>(`${BASE_URL}/Claims`);
  },

  /** Rate limited server-side to 10 creates per minute. */
  async createApiKey(
    request: ICreateIntegrationApiKeyRequest
  ): Promise<AxiosResponse<ICreatedIntegrationApiKey>> {
    return api.post<ICreatedIntegrationApiKey>(BASE_URL, request);
  },

  async updateApiKey(
    id: string,
    request: IUpdateIntegrationApiKeyRequest
  ): Promise<AxiosResponse<IIntegrationApiKey>> {
    return api.put<IIntegrationApiKey>(
      `${BASE_URL}/${encodeURIComponent(id)}`,
      request
    );
  },
};
